/**
 * 下载文件
 * @param {string, Array} text 
 * @param {string} fileName 
 */
const saveTextAsFile = (text, fileName) => {
  let data = text;
  if (!(text instanceof Array)) {
    data = [text];
  }
  const urlObject = window.URL || window.webkitURL || window;
  const export_blob = new Blob(data, {
    type: 'application/octet-stream;charset=utf-8',
    name: fileName
  })
  const url = urlObject.createObjectURL(export_blob);
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  anchor.click()
  urlObject.revokeObjectURL(url)
}

export default saveTextAsFile


// WEBPACK FOOTER //
// ./src/utils/saveTextAsFile.js